import React, { useState, useEffect, useRef } from "react";
import {
  MapContainer,
  TileLayer,
  FeatureGroup,
  useMap,
  Marker,
  Polyline,
} from "react-leaflet";
import { EditControl } from "react-leaflet-draw";
import { LineUtil, Util } from "leaflet";
import L from "leaflet";
import "leaflet-draw/dist/leaflet.draw.css";
import { Button, Spinner } from "reactstrap";
import { postBranchPath } from "../../../helpers/backend_helper";

const InitMap = ({ branch, line, setLine, setBranch }) => {
  const ref = useRef();
  const mapRef = React.useRef();
  const [error, setError] = useState("");
  const [loadMap, setLoadMap] = useState(false);
  const [loading, setLoading] = useState(false);
  const [bounds, setBounds] = useState([
    [19.432608, -99.133209],
    [19.432608, -99.133209],
  ]);

  useEffect(() => {
    if (line.length < 2) return;
    if (!loadMap) return;
    var bounds = L.latLngBounds(line);
    console.log("fit bounds", bounds);
    mapRef.current?.fitBounds(bounds);
  }, [line, loadMap]);

  const save = async () => {
    if (validate()) {
      setLoading(true);
      try {
        const response = await postBranchPath(branch.id, { path: line });
        setEdit(false);
        setBranch(response.branch);
      } catch (error) {
        console.log("error", error);
      }
      setLoading(false);
    }
  };

  const validate = () => {
    let errorsNo = 0;
    errorsNo = line.length < 2 ? errorsNo + 1 : errorsNo;

    if (errorsNo == 0) {
      setError(null);
      return true;
    }
    setError(
      "Debe agregar almenos 1 geocerca e indicar una geocerca intermedia."
    );
    return false;
  };

  return (
    <div style={{ minHeight: "500px" }}>

      <MapContainer
        style={{ minHeight: "500px" }}
        ref={mapRef}
        zoom={13}
        scrollWheelZoom={false}
        bounds={bounds}
        whenReady={(map) => {
          console.log("whenReady", line.length, mapRef.current);
          setLoadMap(true);
        }}
      >
        <TileLayer
          attribution=""
          url="https://mt1.google.com/vt/lyrs=m&x={x}&y={y}&z={z}"
        />
        <FeatureGroup ref={ref}>
          <EditControl
            draw={{
              polyline: false,
              polygon: false,
              rectangle: false,
              circle: false,
              marker: false,
              circlemarker: false,
            }}
            onEdited={(e) => {
              let newLayers = e.layers.getLayers();
              if (newLayers.length == 0) return;

              let json = ref.current?.toGeoJSON();
              ref.current?.removeLayer(ref.current?.getLayers()[0]);
              L.geoJSON(json).eachLayer(function (layer) {
                ref.current?.addLayer(layer);
              });

              console.log(
                newLayers[0]
                  .getLatLngs()
                  .map((latlng) => [latlng.lat, latlng.lng])
              );
              setLine([
                ...newLayers[0]
                  .getLatLngs()
                  .map((latlng) => [latlng.lat, latlng.lng]),
              ]);
            }}
            edit={{
              remove: false,
            }}
          />

          <Polyline positions={line} />
        </FeatureGroup>
        <>
          <Marker
            position={line[0]}
            title="Inicio"
            icon={new L.Icon.Default({ className: "start" })}
          />
          <Marker
            position={line[line.length - 1]}
            title="Final"
            icon={new L.Icon.Default({ className: "end" })}
          />
        </>
      </MapContainer>
      <div className="text-center mt-2">
        <Button color="primary" onClick={save} disabled={loading}>
          {loading && <Spinner size="sm"></Spinner>}{" "}
          <i className="fa fa-save"></i> Guardar
        </Button>
      </div>
    </div>
  );
};

export default InitMap;
